<div #container
     class="flex flex-row
            h-full min-w-[950px] max-w-[100%] box-border pb-4 px-4"
     *ngrxLet="viewModel$; let value">

  <!--    main panel container   -->
  <div #mainPanel
       class="flex flex-col h-full grow overflow-hidden">

    <!--      top panel container     -->
    <!--    TODO: TBD adjust min height validation?    -->
    <div class="flex flex-col w-full grow z-[2]
                rounded-[16px] overflow-hidden bg-neutral-96">
      <app-location-list class="grow overflow-hidden"></app-location-list>
    </div>

    <!--      bottom panel container w/ handle  -->
    <!--    TODO: TBD overflow: auto or adjust min height validation?    -->
    @if (value.bottomPanelActive) {
      <div class="flex flex-col w-full
                  overflow-y-hidden z-[1]"
        [style.flex]="'0 0 ' + value.bottomPanelRelativeHeight + '%'"
        mwlResizable
        (resizing)="onResizeBottomPanel($event)"
        (resizeStart)="onResizeToggle()"
        (resizeEnd)="onResizeToggle()"
        [mouseMoveThrottleMS]="25">

        <!--      vertical handle  -->
        <div class="flex flex-row justify-center items-center
                    w-full h-2
                    bg-neutral-96
                    group hover:cursor-row-resize"
              mwlResizeHandle
              [resizeEdges]="{ top: true }">

          <div class="w-10 h-1
                    bg-neutral-60 group-hover:bg-green-10
                    rounded-[4px]"></div>
        </div>

        <div class="grow rounded-[16px]
                    border border-solid border-neutral-90
                    overflow-y-hidden"
             #bottomContentContainer>

          <!--      bottom panel tab group     -->
          <div class="tabGroup" #tabGroup>
            @for (tab of getEnumValues(bottomPanelTabs); track tab; let first = $first) {
              <div class="tab"
                (click)="value.selectedBottomPanelTab !== tab && onBottomTabClick(tab)"
                [ngClass]="{'active': value.selectedBottomPanelTab === tab,
                            'rounded-tl-[16px]': first}">
                <mat-icon [svgIcon]="getSvgName(tab)"></mat-icon>
                {{tab}}
              </div>
            }
            <div class="grow"></div>
            <button mat-icon-button
                    class="mr-1"
                    (click)="onToggleBottomPanelClick()">
              <mat-icon svgIcon="close"></mat-icon>
            </button>
          </div>
          <div class="bottomTabContent"
               [style.height.px]="(bottomContentContainer.clientHeight - tabGroup.clientHeight)">
            <!--    put bottom panel active tab content here   -->
            @switch (value.selectedBottomPanelTab) {
              @case (bottomPanelTabs.CC_RESULTS) {
                <app-cc-list/>
              }
              @case (bottomPanelTabs.COMPARE) {
                <app-bls-gmb-differences/>
              }
              @case (bottomPanelTabs.UPDATES) {
                <app-bls-updates/>
              }
              @case (bottomPanelTabs.VALIDATION_HISTORY) {
                <app-validation-history/>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>

  <!--    right panel container w/ handle  -->
  @if (value.rightPanelActive) {
    <div
        class="flex h-full box-border pt-4"
      [style.flex]="'0 0 ' + value.rightPanelRelativeWidth + '%'"
      mwlResizable
      (resizing)="onResizeRightPanel($event)"
      (resizeStart)="onResizeToggle()"
      (resizeEnd)="onResizeToggle()"
      [mouseMoveThrottleMS]="25">
      <!--    horizontal handle   -->
    <div class="flex flex-row justify-center items-center
                h-full w-2
                group hover:cursor-col-resize"
        mwlResizeHandle
        [resizeEdges]="{ left: true }">
      <div class="h-10 w-1
                  rounded-[4px]
                  bg-neutral-60 group-hover:bg-green-10"></div>
      </div>
      <div
          class="grow border border-solid border-neutral-90 rounded-[16px] overflow-y-hidden bg-blue-90 flex flex-col">
        <!--      right panel tab group     -->
        <div class="tabGroup">
          @for (tab of getEnumValues(rightPanelTabs); track tab; let first = $first) {
            <div class="tab"
                 (click)="value.selectedRightPanelTab !== tab && onRightTabClick(tab)"
                 [ngClass]="{'active': value.selectedRightPanelTab === tab,
                              'rounded-tl-[16px]': first}">
              <mat-icon [svgIcon]="getSvgName(tab)"></mat-icon>
              {{tab}}
            </div>
          }
          <div class="grow"></div>
          <button mat-icon-button
                  class="mr-1"
                  (click)="onToggleRightPanelClick()">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>
        <!--    put right panel active tab content here   -->
        @switch (value.selectedRightPanelTab) {
          @case (rightPanelTabs.MAP) {
            @if (value.googleMapsApiLoaded) {
              @if (value.cvOn) {
                <app-cv-map class="flex flex-grow flex-col overflow-hidden"/>
              } @else {
                <app-default-map class="flex flex-grow flex-col overflow-hidden"/>
              }
            }
          }
          @case (rightPanelTabs.EDIT) {
            <app-edit-location class="flex flex-grow flex-col overflow-hidden"/>
          }
        }
      </div>
    </div>
  }
</div>
